import '@babel/polyfill';

// Third party libs
import { FocusTrap } from 'focus-trap-vue';
import * as Integrations from '@sentry/integrations';
import * as Sentry from '@sentry/browser';
import Notifications from 'vue-notification';
import Toggle from 'vue-js-toggle-button';
import vmodal from 'vue-js-modal';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import VueCookie from 'vue-cookie';

// Our stuff
import Analytics from '@/plugins/analytics/index';
import App from '@components/app';
import Apptimize from '@/plugins/apptimize/index';
import Authorization from '@/plugins/authorization/index';
import disableable from '@directives/disableable';
import EventBus from '@/plugins/eventBus/index';
import routerSetup from '@/router';
import scrollable from '@directives/scrollable';
import Sheets from '@/plugins/sheets';
import storeSetup from '@/store';
import GAuth from '@/plugins/google-auth';

Vue.config.errorHandler = function(e, vm, info) {
  console.log(e);
};

if (['production', 'staging'].includes(process.env.WEB_ENV)) {
  Sentry.init({
    dsn: `${process.env.SENTRY_DSN}`,
    environment: process.env.WEB_ENV,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: `${process.env.SOURCE_VERSION}`,
  });
}

const gauthOption = {
  clientId: '808656977083-4aavq9am6hiu0ujmr2tn2vu4mt9sg9v5.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
};
Vue.use(GAuth, gauthOption);
Vue.use(VueCookie);

let store = storeSetup(Vue);
let router = routerSetup(Vue, store);

Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.use(Toggle);
Vue.use(Analytics);
Vue.use(Authorization);
Vue.use(Apptimize);
Vue.use(EventBus);
Vue.use(Sheets);
Vue.use(vmodal);
Vue.use(VTooltip);
Vue.directive('disableable', disableable);
Vue.directive('scrollable', scrollable);
Vue.component('FocusTrap', FocusTrap);


window.onload = function() {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  });
};
